import React from 'react'
import { Box, Typography } from "@mui/material"
import { analyzerFilters, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"

export default function AnalyzerHeaderTable({ label, columnKey, rowKey, rowValues, evolutionColumnValues }) {

	const handleOpenEvolutionModal = () => {
		openEvolutionModal.value = {
			filters: analyzerFilters.value,
			price_data: {
				[columnKey]: evolutionColumnValues[label][0][columnKey],
				[rowKey]: rowValues,
			},
			tableRows: evolutionColumnValues[label]
		}
	}

	return <TooltipSeeker title="Show Evolution Chart" key={label}>
		<Box
			sx={{
				my: 0.5,
				cursor: "pointer",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				transition: "background-color 0.3s ease",
				"&:hover .inner-box": {
					backgroundColor: "rgba(0, 0, 0, 0.1)",
				}
			}}
			onClick={handleOpenEvolutionModal}
		>
			<Box
				className="inner-box"
				sx={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					gap: 0.3,
					padding: 0.5,
					borderRadius: "5px",
					transition: "transform 0.3s ease",
				}}
			>
				<IconSeeker icon="magnifying-glass"/>
				<Typography variant="subtitle2">{label}</Typography>
			</Box>
		</Box>
	</TooltipSeeker>
}
